import { render, staticRenderFns } from "./FormDates.vue?vue&type=template&id=3c74105d"
import script from "./FormDates.vue?vue&type=script&lang=js"
export * from "./FormDates.vue?vue&type=script&lang=js"
import style0 from "./FormDates.vue?vue&type=style&index=0&id=3c74105d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports